<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <SharedWindow
    title="Вывод"
    :is-big="isBig"
    :is-center="true"
    @close="handleClose"
  >
    <div :class="b('intro')">
      <p :class="b('subtitle')">
        {{ $t("Средства уйдут на указанный адрес после проверки") }}
      </p>

      <div :class="b('tabs')" role="tablist">
        <button
          type="button"
          :class="b('tab')"
          role="tab"
          :aria-selected="false"
          @click="openFiatWithdrawal"
        >
          Fiat
        </button>
        <button
          type="button"
          :class="b('tab', { active: true })"
          role="tab"
          :aria-selected="true"
        >
          Crypto
        </button>
      </div>
    </div>

    <div v-if="!currencys.length" :class="b('empty')">
      <span :class="b('empty-icon')">₿</span>
      <h5 :class="b('empty-title')">{{ $t("Нечего выводить") }}</h5>
      <p :class="b('empty-text')">
        {{
          $t(
            "На крипто-счетах пока нет средств — пополните баланс, чтобы вывести"
          )
        }}
      </p>
    </div>

    <div v-else :class="b('wrapper')">
      <div :class="b('fields')">
        <div :class="b('field-coin')">
          <p :class="b('field-label')">
            {{ $t("Монета") }}
          </p>

          <SharedSelect
            view="light"
            :options="displayedCurrencyOptions"
            v-model:value="coinId"
            :isCryptoIcon="true"
            :icon="displayedCurrencyIcon"
            @update:value="loadChains"
          />
        </div>

        <div :class="b('field-chain')">
          <p :class="b('field-label')">
            {{ $t("Выберите сеть") }}
          </p>

          <SharedSelect
            :isReadonly="!displayedChainOptions"
            view="light"
            :options="displayedChainOptions"
            v-model:value="chain"
          />
        </div>
      </div>

      <div :class="b('field')" v-if="chain">
        <p :class="b('field-label')">
          {{ $t("Адрес кошелька") }}
        </p>

        <UIInput view="light" v-model="address" />
      </div>

      <div :class="b('field')" v-if="chain">
        <p :class="b('field-label')">
          {{ $t("Адрес тэг кошелька") }}
        </p>

        <UIInput view="light" v-model="addressTag" />
      </div>

      <div :class="b('field-amount')" v-if="chain">
        <div :class="b('field-label')">
          {{ $t("Сумма") }}

          <div :class="b('field-label-actions')">
            <UIButton v-if="chain" label="МИН" view="max" @click="handleMin" />
            <UIButton label="МАКС" view="max" @click="handleMax" />
          </div>
        </div>

        <SharedInputCurrency
          placeholder="Введите сумму"
          :currency="displayedCurrency"
          :value="amount"
          @update:value="handleAmountChange"
        />
        <p :class="b('field-error')" v-if="errorAmountMessage">
          {{ errorAmountMessage }}
        </p>
      </div>

      <div :class="b('field-result')" v-if="!errorAmountMessage">
        <p :class="b('field-label-result')">
          {{ $t("Вы получите") }}
          <b :class="b('result-amount')">{{ resultAmount }}</b>
          {{
            displayedCurrency?.currency?.name.toUpperCase() ||
            displayedCurrency?.name.toUpperCase()
          }}
        </p>
      </div>

      <div :class="b('fields')" v-if="chain">
        <UIButton
          label="Вывести"
          view="main"
          :disabled="isDisabled"
          @click="handleWithdraw"
        />
      </div>
    </div>
  </SharedWindow>
</template>
